/**
 * useEltJobExecutionDetails Hook
 *
 * React Query hook for fetching a single job execution.
 */

import { useQuery } from "@tanstack/react-query";
import { jobExecutionService } from "../../../api/job-execution.service";
import type { EltJobExecution } from "../../../types/elt-job-execution.types";

export const JOB_EXECUTION_DETAILS_QUERY_KEY = "jobExecutionDetails";

export function useEltJobExecutionDetails(tenantId: string, jobExecutionId: string) {
  return useQuery<EltJobExecution, Error>({
    queryKey: [JOB_EXECUTION_DETAILS_QUERY_KEY, tenantId, jobExecutionId],
    queryFn: () => jobExecutionService.getEltJobExecution(tenantId, jobExecutionId),
    enabled: !!tenantId && !!jobExecutionId,
    staleTime: 10000,
    refetchInterval: (query) => {
      // Auto-refetch if execution is still in progress
      const data = query.state.data;
      if (data && (data.status === "pending" || data.status === "in_progress")) {
        return 5000; // Refetch every 5 seconds while in progress
      }
      return false; // Don't auto-refetch when complete
    },
  });
}
